import qknColors from './qknColors';
export { default as qknColors } from './qknColors';

// todo: ideally not use this and reference the palette sequence via index instead so that we respect dark/light mode
export const colorSequence = [
  qknColors.blue[600],
  qknColors.sky[500],
  qknColors.green[600],
  qknColors.cream[600],
  qknColors.yellow[600],
  qknColors.purple[600],
  qknColors.deepOrange[600],
  qknColors.magenta[600],
  qknColors.lime[600],
  qknColors.red[600],
  qknColors.grey[500],
] as const;

export const businessColorSequence = [
  'bizColor1',
  'bizColor2',
  'bizColor3',
  'bizColor4',
  'bizColor5',
  'bizColor6',
  'bizColor7',
  'bizColor8',
  'bizColor9',
  'bizColor10',
] as const;

export const businessColorReadable = Object.freeze({
  bizColor0: 'grey',
  bizColor1: 'sky',
  bizColor2: 'green',
  bizColor3: 'lime',
  bizColor4: 'yellow',
  bizColor5: 'cream',
  bizColor6: 'deepOrange',
  bizColor7: 'red',
  bizColor8: 'magenta',
  bizColor9: 'purple',
  bizColor10: 'blue',
});

export type BusinessColor = (typeof businessColorSequence)[number];
